const InfoTerkiniListItemCard = ({
  data,
  isSelected,
  onClick,
  isDesktop,
}: any) => {
  const cardContent = isDesktop ? (
    <div
      className={`relative flex px-4 py-3 border-b cursor-pointer transition-colors before:content-[""] before:absolute before:left-0 before:top-0 before:h-full before:w-1 ${
        isSelected
          ? 'bg-blue-5 before:bg-blue-500'
          : 'bg-white hover:bg-gray-5 hover:before:bg-gray-300'
      }`}
      data-testid="success-list"
    >
      {data?.thumbnailUrl != '' && (
        <div className="flex-shrink-0 flex-grow-0 rounded mr-3">
          <img
            src={data?.thumbnailUrl}
            alt="image-thumbnail"
            className="object-cover h-16 w-24 rounded"
          />
        </div>
      )}

      <div className="min-w-0 flex-1">
        <div className="text-sm font-semibold line-clamp-2 leading-tight mb-1">
          {data?.title}
        </div>
        <div className="mb-1">
          <span
            className="text-[10px] px-1.5 py-0.5 rounded font-semibold text-white inline-block"
            style={{
              backgroundColor: '#0B5FEF',
            }}
          >
            {data?.category?.name}
          </span>
        </div>
        <div className="text-xs text-gray-500">{data?.publishDate}</div>
      </div>
    </div>
  ) : (
    <div
      className="bg-white px-4 py-3 rounded-lg mb-3"
      data-testid="success-list"
    >
      <div>
        {data?.thumbnailUrl != '' && (
          <img
            src={data?.thumbnailUrl}
            alt="image-thumbnail"
            className="object-cover h-24 w-full rounded"
          />
        )}

        <div className="py-3 text-base font-semibold">{data?.title}</div>
        <div className="pb-3">
          <span
            className="text-xs px-2 py-1 rounded-lg font-semibold text-white"
            style={{
              backgroundColor: '#0B5FEF',
            }}
          >
            {data?.category?.name}
          </span>
        </div>
        <div className="text-sm">{data?.publishDate}</div>
      </div>
    </div>
  )

  if (isDesktop) {
    return <div onClick={onClick}>{cardContent}</div>
  }

  return <a href={`/info-terkini/${data?.id}`}>{cardContent}</a>
}

export default InfoTerkiniListItemCard
